import * as colorPalette from '../palette';

export const pageBackground = colorPalette.gray600;
export const pageBackgroundModalActive = colorPalette.gray700;
export const pageBackgroundTopLeft = colorPalette.gray800;
export const pageBackgroundBottomRight = colorPalette.gray700;
export const pageBackgroundLineTop = colorPalette.green600;
export const pageBackgroundLineMid = colorPalette.gray900;
export const pageBackgroundLineBottom = colorPalette.gray150;
export const pageText = colorPalette.gray100;
export const pageTextLight = colorPalette.gray200;
export const pageTextSubdued = colorPalette.gray400;
export const pageTextDark = colorPalette.gray100;
export const pageTextPositive = colorPalette.green400;
export const pageTextLink = colorPalette.purple300;
export const pageTextLinkLight = colorPalette.purple300;

export const cardBackground = colorPalette.gray800;
export const cardBorder = colorPalette.purple300;
export const cardShadow = colorPalette.gray900;

export const tableBackground = colorPalette.gray800;
export const tableRowBackgroundHover = colorPalette.gray500;
export const tableText = colorPalette.gray150;
export const tableTextLight = tableText;
export const tableTextSubdued = colorPalette.gray500;
export const tableTextSelected = colorPalette.gray800;
export const tableTextHover = colorPalette.gray400;
export const tableTextInactive = colorPalette.gray400;
export const tableHeaderText = colorPalette.gray200;
export const tableHeaderBackground = colorPalette.gray900;
export const tableBorder = colorPalette.gray600;
export const tableBorderSelected = colorPalette.purple400;
export const tableBorderHover = colorPalette.green500;
export const tableBorderSeparator = colorPalette.gray400;
export const tableRowBackgroundHighlight = colorPalette.purple150;
export const tableRowBackgroundHighlightText = colorPalette.gray800;
export const tableRowHeaderBackground = colorPalette.gray700;
export const tableRowHeaderText = colorPalette.gray150;

export const sidebarBackground = colorPalette.gray900;
export const sidebarItemBackgroundPending = colorPalette.orange200;
export const sidebarItemBackgroundPositive = colorPalette.green400;
export const sidebarItemBackgroundFailed = colorPalette.red300;
export const sidebarItemAccentSelected = colorPalette.green500;
export const sidebarItemBackgroundHover = colorPalette.gray700;
export const sidebarItemText = colorPalette.gray100;
export const sidebarItemTextSelected = colorPalette.green200;

export const menuBackground = colorPalette.gray700;
export const menuItemBackground = colorPalette.gray200;
export const menuItemBackgroundHover = colorPalette.gray500;
export const menuItemText = colorPalette.gray100;
export const menuItemTextHover = colorPalette.gray50;
export const menuItemTextSelected = colorPalette.purple400;
export const menuItemTextHeader = colorPalette.purple200;
export const menuBorder = colorPalette.gray800;
export const menuBorderHover = colorPalette.purple300;
export const menuKeybindingText = colorPalette.gray500;
export const menuAutoCompleteBackground = colorPalette.gray600;
export const menuAutoCompleteBackgroundHover = colorPalette.gray500;
export const menuAutoCompleteText = colorPalette.gray100;
export const menuAutoCompleteTextHover = colorPalette.green900;
export const menuAutoCompleteTextHeader = colorPalette.green200;
export const menuAutoCompleteItemTextHover = colorPalette.gray50;
export const menuAutoCompleteItemText = menuItemText;
export const modalBackground = colorPalette.gray700;
export const modalBorder = colorPalette.gray200;
export const mobileHeaderBackground = colorPalette.green900;
export const mobileHeaderText = colorPalette.purple200;
export const mobileHeaderTextSubdued = colorPalette.gray200;
export const mobileHeaderTextHover = 'rgba(200, 200, 200, .15)';
export const mobilePageBackground = colorPalette.gray900;
export const mobileNavBackground = colorPalette.gray600;
export const mobileNavItem = colorPalette.gray150;
export const mobileNavItemSelected = colorPalette.green400;
export const mobileAccountShadow = cardShadow;
export const mobileAccountText = colorPalette.blue800;
export const mobileTransactionSelected = colorPalette.purple300;

// Mobile view themes (for the top bar)
export const mobileViewTheme = mobileHeaderBackground;
export const mobileConfigServerViewTheme = colorPalette.purple500;

export const markdownNormal = colorPalette.purple700;
export const markdownDark = colorPalette.purple500;
export const markdownLight = colorPalette.purple800;

// Button
export const buttonMenuText = colorPalette.gray200;
export const buttonMenuTextHover = buttonMenuText;
export const buttonMenuBackground = colorPalette.gray700;
export const buttonMenuBackgroundHover = 'rgba(200, 200, 200, .25)';
export const buttonMenuBorder = colorPalette.gray500;
export const buttonMenuSelectedText = colorPalette.green800;
export const buttonMenuSelectedTextHover = colorPalette.orange800;
export const buttonMenuSelectedBackground = colorPalette.orange200;
export const buttonMenuSelectedBackgroundHover = colorPalette.gray300;
export const buttonMenuSelectedBorder = buttonMenuSelectedBackground;

export const buttonPrimaryText = colorPalette.white;
export const buttonPrimaryTextHover = buttonPrimaryText;
export const buttonPrimaryBackground = colorPalette.green600;
export const buttonPrimaryBackgroundHover = colorPalette.green900;
export const buttonPrimaryBorder = buttonPrimaryBackground;
export const buttonPrimaryShadow = 'rgba(0, 0, 0, 0.6)';
export const buttonPrimaryDisabledText = colorPalette.gray400;
export const buttonPrimaryDisabledBackground = colorPalette.gray700;
export const buttonPrimaryDisabledBorder = buttonPrimaryDisabledBackground;

export const buttonNormalText = colorPalette.gray150;
export const buttonNormalTextHover = colorPalette.gray150;
export const buttonNormalBackground = colorPalette.gray600;
export const buttonNormalBackgroundHover = colorPalette.gray400;
export const buttonNormalBorder = colorPalette.gray300;
export const buttonNormalShadow = 'rgba(0, 0, 0, 0.4)';
export const buttonNormalSelectedText = colorPalette.white;
export const buttonNormalSelectedBackground = colorPalette.purple500;
export const buttonNormalDisabledText = colorPalette.gray400;
export const buttonNormalDisabledBackground = colorPalette.gray700;
export const buttonNormalDisabledBorder = colorPalette.gray500;

export const calendarText = colorPalette.gray50;
export const calendarBackground = colorPalette.gray700;
export const calendarItemText = colorPalette.gray150;
export const calendarItemBackground = colorPalette.gray500;
export const calendarSelectedBackground = buttonNormalSelectedBackground;

export const buttonBareText = buttonNormalText;
export const buttonBareTextHover = buttonNormalText;
export const buttonBareBackground = 'transparent';
export const buttonBareBackgroundHover = 'rgba(200, 200, 200, .3)';
export const buttonBareBackgroundActive = 'rgba(200, 200, 200, .5)';
export const buttonBareDisabledText = buttonNormalDisabledText;
export const buttonBareDisabledBackground = buttonBareBackground;

export const noticeBackground = colorPalette.green600;
export const noticeBackgroundLight = colorPalette.green900;
export const noticeBackgroundDark = colorPalette.green400;
export const noticeText = colorPalette.green300;
export const noticeTextLight = colorPalette.green400;
export const noticeTextDark = colorPalette.green150;
export const noticeTextMenu = colorPalette.green400;
export const noticeTextMenuHover = colorPalette.green700;
export const noticeBorder = colorPalette.green800;
export const warningBackground = colorPalette.orange800;
export const warningText = colorPalette.orange200;
export const warningTextLight = colorPalette.orange500;
export const warningTextDark = colorPalette.orange100;
export const warningBorder = colorPalette.orange500;
export const errorBackground = colorPalette.red800;
export const errorText = colorPalette.red200;
export const errorTextDark = colorPalette.red150;
export const errorTextDarker = errorTextDark;
export const errorTextMenu = colorPalette.red200;
export const errorBorder = colorPalette.red500;
export const upcomingBackground = colorPalette.purple800;
export const upcomingText = colorPalette.purple200;
export const upcomingBorder = tableBorder;

export const formLabelText = colorPalette.purple150;
export const formLabelBackground = colorPalette.blue900;
export const formInputBackground = colorPalette.gray800;
export const formInputBackgroundSelected = colorPalette.gray700;
export const formInputBackgroundSelection = colorPalette.purple400;
export const formInputBorder = colorPalette.gray600;
export const formInputTextReadOnlySelection = colorPalette.gray800;
export const formInputBorderSelected = colorPalette.green600;
export const formInputText = colorPalette.gray150;
export const formInputTextSelected = colorPalette.black;
export const formInputTextPlaceholder = colorPalette.gray150;
export const formInputTextPlaceholderSelected = colorPalette.gray100;
export const formInputTextSelection = colorPalette.gray800;
export const formInputShadowSelected = colorPalette.purple400;
export const formInputTextHighlight = colorPalette.green200;
export const checkboxText = tableText;
export const checkboxToggleBackground = colorPalette.gray400;
export const checkboxBackgroundSelected = colorPalette.green500;
export const checkboxBorderSelected = colorPalette.green500;
export const checkboxShadowSelected = colorPalette.green700;

export const pillBackground = colorPalette.gray500;
export const pillBackgroundLight = colorPalette.gray900;
export const pillText = colorPalette.gray200;
export const pillTextHighlighted = colorPalette.green300;
export const pillBorder = colorPalette.gray500;
export const pillBorderDark = pillBorder;
export const pillBackgroundSelected = colorPalette.purple600;
export const pillTextSelected = colorPalette.gray150;
export const pillBorderSelected = colorPalette.purple300;
export const pillTextSubdued = colorPalette.gray500;

export const reportsRed = colorPalette.red300;
export const reportsBlue = colorPalette.blue400;
export const reportsGreen = colorPalette.green400;
export const reportsLabel = pageText;
export const reportsInnerLabel = colorPalette.navy800;

export const progressBarFounded = colorPalette.green600;
export const progressBarSpentOk = colorPalette.green400;
export const progressBarUnderfounded = colorPalette.red600;
export const progressBarUntouchedCategory = colorPalette.gray300;

export const noteTagBackground = colorPalette.green800;
export const noteTagBackgroundHover = colorPalette.green600;
export const noteTagText = colorPalette.green100;

export const budgetOtherMonth = colorPalette.gray700;
export const budgetCurrentMonth = tableBackground;
export const budgetHeaderOtherMonth = colorPalette.gray800;
export const budgetHeaderCurrentMonth = tableHeaderBackground;

export const floatingActionBarBackground = colorPalette.gray900;
export const floatingActionBarBorder = colorPalette.purple300;
export const floatingActionBarText = colorPalette.purple200;
